import { Link } from 'react-router-dom';
import { partners } from '@/mocks/home';

export default function PartnersSection() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <p className="text-center text-xs text-foreground-400 font-medium tracking-wider mb-8">
          合作伙伴
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
          {partners.map((partner) => (
            <span
              key={partner.id}
              className="text-sm md:text-base font-semibold text-foreground-300 hover:text-foreground-500 transition-colors cursor-default"
            >
              {partner.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="rounded-3xl bg-primary-500 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
          </div>
          <div className="relative z-10 py-14 md:py-20 px-6 md:px-12 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
              准备好开启全新体验了吗？
            </h2>
            <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-8">
              立即联系我们的专业团队，获取专属解决方案与一对一咨询服务。aiye 期待与您携手共创价值。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full bg-white text-primary-600 font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即咨询
              </Link>
              <Link
                to="/category/smart-solutions"
                className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-semibold text-sm md:text-base hover:bg-white/10 hover:border-white/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览产品
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}